<template>
    <v-container v-if="answerlist" class="pa-2" fluid grid-list-sm > 
        <v-tabs
            center-active 
            color="blue" slider-color="blue"
            class="customTabTitle"
            >
            <v-tab v-for="(filename, index) in answerlist" :key="index" @click="activeIndex = index">                                    
                {{answerlist[index].filename}} &nbsp;
            </v-tab>
        </v-tabs>
        <codemirror 
            v-if="activeIndex > -1" 
            class="border-top" 
            v-model="answerlist[activeIndex].filecontent" 
            :options="getCmOptions()"
            >
        </codemirror>  
    </v-container>
</template>

<script>

import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.js'
// language js
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/clike/clike.js'

// language hint addons
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/hint/xml-hint.js'
import 'codemirror/addon/hint/html-hint.js'
import 'codemirror/addon/hint/sql-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'

export default {
    data() {
        return {
            answerlist: null,
            activeIndex: -1
        }
    },    
    props: ['answer'],
    components: {
        codemirror
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {
            try {
                this.answerlist = JSON.parse(this.answer)
                this.activeIndex = 0
            } catch (error) { this.answerlist = null }
        },
        getCmOptions() {
            return  {
                tabSize: 4,
                styleActiveLine: true,
                lineNumbers: true,
                line: true,
                //scrollbarStyle: 'simple',
                mode: this.$store.getters.getEditorType,
                lineWrapping: false,
                extraKeys: {'Ctrl-Space': 'autocomplete'}
            }
        },
    }

}

</script>
